var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIdCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 32C10.25 29.2386 12.4886 27 15.25 27H97.25C100.011 27 102.25 29.2386 102.25 32V39H10.25V32Z",
    fill: "#E6F6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 32C10.25 29.2386 12.4886 27 15.25 27H97.25C100.011 27 102.25 29.2386 102.25 32V80C102.25 82.7614 100.011 85 97.25 85H15.25C12.4886 85 10.25 82.7614 10.25 80V32ZM15.25 29C13.5931 29 12.25 30.3431 12.25 32V80C12.25 81.6569 13.5931 83 15.25 83H97.25C98.9069 83 100.25 81.6569 100.25 80V32C100.25 30.3431 98.9069 29 97.25 29H15.25Z",
    fill: "#4DC370"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 47,
    width: 23,
    height: 29,
    rx: 2,
    fill: "#9CDBAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6761 62.7916C33.3799 62.7916 35.5718 60.5996 35.5718 57.8958C35.5718 55.1919 33.3799 53 30.6761 53C27.9722 53 25.7803 55.1919 25.7803 57.8958C25.7803 60.5996 27.9722 62.7916 30.6761 62.7916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3261 72.9941C39.3261 70.7297 38.4266 68.558 36.8254 66.9568C35.2242 65.3556 33.0525 64.4561 30.7881 64.4561C28.5236 64.4561 26.3519 65.3556 24.7507 66.9568C23.1495 68.558 22.25 70.7297 22.25 72.9941H39.3261Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.25 50H48.25V53H90.25V50Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 57H48.25V60H75.25V57Z",
    fill: "#F1F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.25 69H48.25V72H85.25V69Z",
    fill: "#F1F1F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIdCard);
export default __webpack_public_path__ + "static/media/ic_id_card.7369251b6fc8453eef57077896a6539d.svg";
export { ForwardRef as ReactComponent };